/** One limit covers concurrent batches, retries, and authorized registration. */
export function createComposerUploadScheduler(limit = 3) {
  let active = 0;
  const waiting: Array<() => void> = [];
  return {
    run(task: () => Promise<void>, signal: AbortSignal): Promise<void> {
      return new Promise((resolve, reject) => {
        const cancelWaiting = () => {
          const index = waiting.indexOf(start);
          if (index >= 0) waiting.splice(index, 1);
          signal.removeEventListener('abort', cancelWaiting);
          resolve();
        };
        const start = () => {
          signal.removeEventListener('abort', cancelWaiting);
          if (signal.aborted) {
            resolve();
            return;
          }
          active += 1;
          const finish = () => {
            active -= 1;
            while (active < limit && waiting.length) waiting.shift()?.();
          };
          try {
            void task().then(resolve, reject).finally(finish);
          } catch (error) {
            reject(error);
            finish();
          }
        };
        if (signal.aborted) {
          resolve();
          return;
        }
        if (active < limit) start();
        else {
          waiting.push(start);
          signal.addEventListener('abort', cancelWaiting, { once: true });
        }
      });
    },
  };
}
